/* OutIn: show prices as "RM1,234.00" without the trailing " MYR".
   Bridge only: the proper fix is Shopify Admin > Settings > General > Currency display > Change formatting
   (set all four formats to RM{{amount}}). This script removes the code from visible text on the storefront until then
   and can be deleted afterwards (also remove its <script> line at the end of snippets/outin-voucher-popup.liquid). */
(function () {
  var RE = /(RM\s?[\d.,]+)\s*MYR\b/g;
  function fix(node) {
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var n, list = [];
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf('MYR') > -1) list.push(n); }
    list.forEach(function (t) { t.nodeValue = t.nodeValue.replace(RE, '$1'); });
  }
  function run() { try { fix(document.body); } catch (e) {} }
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  try {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
})();